import React from 'react';

import { IconProps } from '../DefaultIcon';

export function ContactosInternosIcon({ className }: IconProps) {
  return (
    <svg
      width="62"
      height="81"
      viewBox="0 0 62 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_2_807)">
        <path
          d="M56.0241 81H5.72691C2.48996 81 0 78.4845 0 75.2143V5.78571C0 2.51553 2.48996 0 5.72691 0H56.0241C59.261 0 61.751 2.51553 61.751 5.78571V74.9627C62 78.2329 59.261 81 56.0241 81Z"
          fill="#EAEEF9"
        />
        <path
          d="M53.2851 72.1957H8.71484C6.22488 72.1957 4.23291 70.1832 4.23291 67.6677V13.3323C4.23291 10.8168 6.22488 8.80434 8.71484 8.80434H53.2851C55.7751 8.80434 57.767 10.8168 57.767 13.3323V67.9193C57.5181 70.1832 55.5261 72.1957 53.2851 72.1957Z"
          fill="#00416B"
        />
        <path
          d="M53.5341 70.1832H8.46582C7.22084 70.1832 6.22485 69.177 6.22485 67.9193V12.8292C6.22485 11.5714 7.22084 10.5652 8.46582 10.5652H53.5341C54.7791 10.5652 55.7751 11.5714 55.7751 12.8292V67.9193C55.7751 69.4286 54.7791 70.1832 53.5341 70.1832Z"
          fill="white"
        />
        <path
          d="M53.5341 70.1832H8.46582C7.22084 70.1832 6.22485 69.177 6.22485 67.9193V51.0652H55.7751V67.9193C55.7751 69.4286 54.7791 70.1832 53.5341 70.1832Z"
          fill="#EAEEF9"
        />
        <path
          d="M33.1165 46.7888H28.6346C27.1406 46.7888 25.6466 45.5311 25.6466 43.7702V39.2422C25.6466 37.7329 26.8916 36.2236 28.6346 36.2236H33.1165C34.6105 36.2236 36.1044 37.4814 36.1044 39.2422V43.7702C36.1044 45.5311 34.8595 46.7888 33.1165 46.7888Z"
          fill="#00C4B3"
        />
        <path
          d="M17.9278 46.7888H13.4458C11.9519 46.7888 10.4579 45.5311 10.4579 43.7702V39.2422C10.4579 37.7329 11.7029 36.2236 13.4458 36.2236H17.9278C19.4217 36.2236 20.9157 37.4814 20.9157 39.2422V43.7702C20.6667 45.5311 19.4217 46.7888 17.9278 46.7888Z"
          fill="#00C4B3"
        />
        <path
          d="M48.5542 46.7888H44.0723C42.5783 46.7888 41.0844 45.5311 41.0844 43.7702V39.2422C41.0844 37.7329 42.3293 36.2236 44.0723 36.2236H48.5542C50.0482 36.2236 51.5422 37.4814 51.5422 39.2422V43.7702C51.2932 45.5311 50.0482 46.7888 48.5542 46.7888Z"
          fill="#00C4B3"
        />
        <path
          d="M33.1165 31.1925H28.6346C27.1406 31.1925 25.6466 29.9348 25.6466 28.1739V23.8975C25.6466 22.3882 26.8916 20.8789 28.6346 20.8789H33.1165C34.6105 20.8789 36.1044 22.1366 36.1044 23.8975V28.4255C36.1044 29.9348 34.8595 31.1925 33.1165 31.1925Z"
          fill="#00C4B3"
        />
        <path
          d="M17.9278 31.1925H13.4458C11.9519 31.1925 10.4579 29.9348 10.4579 28.1739V23.8975C10.4579 22.3882 11.7029 20.8789 13.4458 20.8789H17.9278C19.4217 20.8789 20.9157 22.1366 20.9157 23.8975V28.4255C20.6667 29.9348 19.4217 31.1925 17.9278 31.1925Z"
          fill="#00C4B3"
        />
        <path
          d="M48.5542 31.1925H44.0723C42.5783 31.1925 41.0844 29.9348 41.0844 28.1739V23.8975C41.0844 22.3882 42.3293 20.8789 44.0723 20.8789H48.5542C50.0482 20.8789 51.5422 22.1366 51.5422 23.8975V28.4255C51.2932 29.9348 50.0482 31.1925 48.5542 31.1925Z"
          fill="#00C4B3"
        />
        <path
          d="M33.1165 65.9068H28.6346C27.1406 65.9068 25.6466 64.6491 25.6466 62.8882V58.3602C25.6466 56.8509 26.8916 55.3416 28.6346 55.3416H33.1165C34.6105 55.3416 36.1044 56.5994 36.1044 58.3602V62.8882C36.1044 64.6491 34.8595 65.9068 33.1165 65.9068Z"
          fill="#00C4B3"
        />
        <path
          d="M17.9278 65.9068H13.4458C11.9519 65.9068 10.4579 64.6491 10.4579 62.8882V58.3602C10.4579 56.8509 11.7029 55.3416 13.4458 55.3416H17.9278C19.4217 55.3416 20.9157 56.5994 20.9157 58.3602V62.8882C20.6667 64.6491 19.4217 65.9068 17.9278 65.9068Z"
          fill="#00C4B3"
        />
        <path
          d="M48.5542 65.9068H44.0723C42.5783 65.9068 41.0844 64.6491 41.0844 62.8882V58.3602C41.0844 56.8509 42.3293 55.3416 44.0723 55.3416H48.5542C50.0482 55.3416 51.5422 56.5994 51.5422 58.3602V62.8882C51.2932 64.6491 50.0482 65.9068 48.5542 65.9068Z"
          fill="#00C4B3"
        />
        <path
          d="M36.3534 5.53416H25.3976C24.8996 5.53416 24.4016 5.03105 24.4016 4.52795C24.4016 4.02484 24.8996 3.52174 25.3976 3.52174H36.3534C36.8514 3.52174 37.3494 4.02484 37.3494 4.52795C37.3494 5.03105 37.1004 5.53416 36.3534 5.53416Z"
          fill="white"
        />
        <path
          d="M51.7912 15.8478H46.0643C45.3173 15.8478 44.5703 15.0932 44.5703 14.3385C44.5703 13.5839 45.3173 12.8292 46.0643 12.8292H51.7912C52.5382 12.8292 53.2852 13.5839 53.2852 14.3385C53.2852 15.0932 52.5382 15.8478 51.7912 15.8478Z"
          fill="#00416B"
        />
        <path
          d="M42.3293 6.03726C43.1544 6.03726 43.8233 5.36152 43.8233 4.52795C43.8233 3.69437 43.1544 3.01863 42.3293 3.01863C41.5042 3.01863 40.8353 3.69437 40.8353 4.52795C40.8353 5.36152 41.5042 6.03726 42.3293 6.03726Z"
          fill="white"
        />
        <path
          d="M9.9598 15.8478C10.7849 15.8478 11.4538 15.1721 11.4538 14.3385C11.4538 13.5049 10.7849 12.8292 9.9598 12.8292C9.1347 12.8292 8.46582 13.5049 8.46582 14.3385C8.46582 15.1721 9.1347 15.8478 9.9598 15.8478Z"
          fill="#00416B"
        />
        <path
          d="M14.9398 15.8478C15.7649 15.8478 16.4338 15.1721 16.4338 14.3385C16.4338 13.5049 15.7649 12.8292 14.9398 12.8292C14.1147 12.8292 13.4458 13.5049 13.4458 14.3385C13.4458 15.1721 14.1147 15.8478 14.9398 15.8478Z"
          fill="#00416B"
        />
        <path
          d="M20.1687 15.8478C20.9938 15.8478 21.6626 15.1721 21.6626 14.3385C21.6626 13.5049 20.9938 12.8292 20.1687 12.8292C19.3436 12.8292 18.6747 13.5049 18.6747 14.3385C18.6747 15.1721 19.3436 15.8478 20.1687 15.8478Z"
          fill="#00416B"
        />
        <path
          d="M25.1486 15.8478C25.9737 15.8478 26.6426 15.1721 26.6426 14.3385C26.6426 13.5049 25.9737 12.8292 25.1486 12.8292C24.3235 12.8292 23.6547 13.5049 23.6547 14.3385C23.6547 15.1721 24.3235 15.8478 25.1486 15.8478Z"
          fill="#00416B"
        />
        <path
          d="M30.8755 78.2329C31.8382 78.2329 32.6185 77.4445 32.6185 76.472C32.6185 75.4995 31.8382 74.7112 30.8755 74.7112C29.9129 74.7112 29.1326 75.4995 29.1326 76.472C29.1326 77.4445 29.9129 78.2329 30.8755 78.2329Z"
          fill="white"
        />
        <path
          d="M44.8193 78.2329C45.7819 78.2329 46.5622 77.4445 46.5622 76.472C46.5622 75.4995 45.7819 74.7112 44.8193 74.7112C43.8567 74.7112 43.0763 75.4995 43.0763 76.472C43.0763 77.4445 43.8567 78.2329 44.8193 78.2329Z"
          fill="white"
        />
        <path
          d="M17.1807 78.2329C18.1433 78.2329 18.9237 77.4445 18.9237 76.472C18.9237 75.4995 18.1433 74.7112 17.1807 74.7112C16.2181 74.7112 15.4377 75.4995 15.4377 76.472C15.4377 77.4445 16.2181 78.2329 17.1807 78.2329Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2_807">
          <rect width="62" height="81" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
